import axios from 'axios';
import { BASE_API_URL } from '../config/environment';
import { Item } from '@shared/interfaces';

type GetItemsResponse = {
  processObjects: Item[];
  total: number;
};

export const getItems = async (filterQuery?: URLSearchParams) => {
  let filters = '?includeCompleted=true&includeCompletedToday=true';
  if (filterQuery) {
    filters += `&${filterQuery.toString()}`;
  }
  const url = `${BASE_API_URL}/process_objects${filters}`;

  const res = await axios.get<GetItemsResponse>(url);
  return res.data.processObjects;
};
